// extracted by mini-css-extract-plugin
export default {"customizeCardButton":"customizeCardButton__1yfEP","existingDraftsForCardSuiteModal":"existingDraftsForCardSuiteModal__x-xhm","mobileFullWidth":"mobileFullWidth__Muqoq"};